export default __webpack_public_path__ + "static/media/open-items-active.dd2dbf81.svg";